<template>
    <div class="followup-navigation mt-3">
        <div class="nav-tabs-wrapper">
            <router-link 
                :to="{ name: 'FollowUpList' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'FollowUpList' }"
            >
                <i class="fas fa-list"></i>
                <span>Daftar Follow Up</span>
            </router-link>
            <router-link
                :to="{ name: 'FollowUpContactHistory' }"
                class="nav-tab-item"
                :class="{ active: $route.name === 'FollowUpContactHistory' }"
            >
                <i class="fas fa-history"></i>
                <span>Kontak Follow Up</span>
            </router-link>
            <router-link
                :to="{ name: 'FollowUpImport' }"
                class="nav-tab-item"
                :class="{ active: $route.name === 'FollowUpImport' }"
            >
                <i class="fas fa-file-import"></i>
                <span>Import Kontak</span>
            </router-link>
            <router-link 
                :to="{ name: 'FollowUpTemplate' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'FollowUpTemplate' }"
            >
                <i class="fas fa-file-alt"></i>
                <span>Template Pesan</span>
            </router-link>
            <router-link 
                :to="{ name: 'FollowUpStats' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'FollowUpStats' }"
            >
                <i class="fas fa-chart-bar"></i>
                <span>Statistik & Laporan</span>
            </router-link>
            <router-link 
                :to="{ name: 'FollowUpSettings' }" 
                class="nav-tab-item"
                :class="{ active: $route.name === 'FollowUpSettings' }"
            >
                <i class="fas fa-cog"></i>
                <span>Pengaturan</span>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FollowUpNavigation'
};
</script>

<style scoped>
.followup-navigation {
    /* margin-bottom: 30px; */
    background: #fff;
    border-radius: 12px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8ecef;
}

.nav-tabs-wrapper {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.nav-tab-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 8px;
    text-decoration: none;
    color: #6c757d;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s ease;
    position: relative;
    background: transparent;
    border: 1px solid transparent;
    white-space: nowrap;
}

.nav-tab-item i {
    font-size: 16px;
    width: 18px;
    text-align: center;
    transition: all 0.3s ease;
}

.nav-tab-item:hover {
    color: #1976d2;
    background: #f8f9fa;
    border-color: #e9ecef;
    transform: translateY(-1px);
}

.nav-tab-item.active {
    color: #fff;
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    border-color: #1976d2;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
    transform: translateY(-2px);
}

.nav-tab-item.active i {
    color: #fff;
    transform: scale(1.1);
}

.nav-tab-item.active:hover {
    background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
    transform: translateY(-2px);
}

@media (max-width: 768px) {
    .nav-tabs-wrapper {
        flex-direction: column;
    }
    
    .nav-tab-item {
        width: 100%;
        justify-content: flex-start;
    }
    
    .nav-tab-item span {
        flex: 1;
    }
}

@media (max-width: 576px) {
    .followup-navigation {
        padding: 6px;
    }
    
    .nav-tab-item {
        padding: 10px 16px;
        font-size: 13px;
    }
    
    .nav-tab-item i {
        font-size: 14px;
    }
}
</style>


